import Vue from "vue";

import PortalVue from "portal-vue";
import Vue2TouchEvents from "vue2-touch-events";
import store from "./shared/store";

import App from "./App.vue";
import router from "./shared/router";

import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import Responsive from "@/shared/plugins/responsive/responsive";
import { initDatadog, datadogAddError } from "@/shared/scripts/datadog";

// Intersection Observer polyfill
import "intersection-observer";

// Import Custom Prototypes
import "./prototypes";
import "../utils/thor.js";
import "../utils/kameleoon.js";
import "../utils/refiner.io.js";

initDatadog();

// Enable plugins
Vue.use(PortalVue);
Vue.use(Responsive, { store : store });
Vue.use(Vue2TouchEvents, {
    swipeTolerance: 100
});

Vue.config.productionTip = false;

Vue.config.errorHandler = function(err, vm, info) {
    datadogAddError(err, {
        vueInfo  : info,
        component: vm?.$options?.name
    });
    if (process.env.NODE_ENV !== "production") {
        console.error(err);
    }
};

window.addEventListener("unhandledrejection", function(event) {
    datadogAddError(event.reason);
});

Vue.directive("scroll", {
    inserted: function (el, binding) {
        const f = function (evt: Event) {
            if (binding.value(evt, el)) {
                window.removeEventListener("scroll", f);
            }
        };
        window.addEventListener("scroll", f);
    }
});

export const app = new Vue({
    router: router,
    store: store,
    i18n: i18n,
    render: h => h(App)
}).$mount("#app");
